import { Component, EventEmitter, OnInit, Output, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../layoutservice';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  @Output() displayChange = new EventEmitter<boolean>();
  isDisplayed: boolean = false;
  show?: boolean;
  mobileMenuItems: any[] = [];
  isMobileMenuOpen: boolean = false;
  isMobile: boolean = false;
  loading: boolean = false;
  fullName: string = '';

  constructor(private router: Router, private layoutService: LayoutService) {}

  ngOnInit() {
    this.checkIsMobile();
    this.layoutService.menuItems$.subscribe((menuItems) => {
      this.mobileMenuItems = menuItems;
    });
    const _userProfile = localStorage.getItem("userProfile");
    const _parsedProfile = _userProfile ? JSON.parse(_userProfile) : null;
    this.fullName = `${_parsedProfile?.data?.firstName ?? ""} ${_parsedProfile?.data?.lastName ?? ""}`;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    this.mobileMenuItems.forEach(menuItem => menuItem.showSubmenu = false);
  }

  setActiveMenuItem(item: any) {
    this.mobileMenuItems.forEach(menuItem => menuItem.showSubmenu = false);
    if (!item.isExternal) {
      this.router.navigate([item.link]);
    } else {
      window.location.href = item.link;
    }
    this.isMobileMenuOpen = false;
  }

  showPanel() {
    if (this.show)
      this.show = false;
    else
      this.show = true;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkIsMobile();
  }

  checkIsMobile() {
    this.isMobile = window.innerWidth <= 767;
  }

  signOut() {
    this.loading = true;
    localStorage.clear();
    sessionStorage.clear();
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    this.router.navigate(['/login']);
    this.loading = false;
  }
}